import { CanActivateFn, Router } from '@angular/router';
import { routeConfigs } from '../constants/route.config';
import { AuthService } from '../services/auth/auth.service';
import { inject } from '@angular/core';
import { getRouteUrl } from '../constants/route.config';
import { ApiService } from '../services/api/api.service';

export const AuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);

  if (AuthService.authorized) {
    return true;
  }

  return router.createUrlTree([routeConfigs.auth.login.path], {
    queryParams: { returnUrl: state.url },
  });
};

export const ProxyOnlyGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const user = authService.getCurrentUser();
  const hubName = route.parent?.params['hubName'] || route.params['hubName'] || user?.hubName || user?.userName;

  if (user?.isProxying) {
    return true;
  }

  return router.createUrlTree([
    getRouteUrl(routeConfigs.dashboard.eventCalendar, {
      hubName,
    }),
  ]);
};

export const EventAggregatorAdminGuard: CanActivateFn = (route) => {
  const router = inject(Router);
  const apiService = inject(ApiService);
  const token = route.queryParams['token'];
  if (token) {
    apiService.setAuthorizationHeader(token);
    return true;
  }
  if (AuthService.authorized) return true;
  return router.createUrlTree([routeConfigs.auth.login.path]);
};
